import Select from '@atlaskit/select';
import TextField from '@atlaskit/textfield';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import useForumCategories from 'hooks/ai-forums/useForumCategories';
import { Field, type FieldProps } from '@atlaskit/form';
// import { Editor } from '../../../components/Editor/Editor';
import { startTransition, useState } from 'react';
import { usePreloadedQuery, useQueryLoader } from 'react-relay';
import GET_TAG_SUGGESTIONS_QUERY, {
  GetTagSuggestionsQuery,
} from '../../../graphql/__generated__/GetTagSuggestionsQuery.graphql';
import Button from '@atlaskit/button';

const TagSuggestionsContainer = ({ queryReference }: { queryReference: any }) => {
  const data = usePreloadedQuery<GetTagSuggestionsQuery>(GET_TAG_SUGGESTIONS_QUERY, queryReference);
  if (!data) {
    return null;
  }
  const tagSuggestions = data?.unified?.ai?.getTagSuggestions?.edges?.map((edge) => edge?.node?.tag) ?? null;

  return <div>{tagSuggestions?.join(', ')}</div>;
};

export const QuestionFormInputs = () => {
  const { normalizedFilterOptions } = useForumCategories();
  const [queryReference, loadQuery] = useQueryLoader(GET_TAG_SUGGESTIONS_QUERY);
  const [title, setTitle] = useState('');
  const [content] = useState('');

  const handleTagSuggestions = () => {
    if (title && content) {
      //disposeQuery();
      startTransition(() => {
        loadQuery({
          title,
          content,
        });
      });
    }
  };

  const getSelectValue = (fieldProps: FieldProps<string>) => {
    const value =
      normalizedFilterOptions
        .flatMap((group) => ('options' in group ? group.options : [group]))
        .find((opt) => opt.value === fieldProps.value) || null;

    return value;
  };

  return (
    <>
      <Field name="category" defaultValue="">
        {({ fieldProps, error }) => (
          <div>
            <div css={labelStyle}>Product</div>
            <Select
              placeholder="Choose from the following Atlassian products"
              options={normalizedFilterOptions}
              isSearchable
              isClearable
              css={selectStyle}
              value={getSelectValue(fieldProps)}
              onChange={(option) => fieldProps.onChange(option?.value || '')}
            />
            {error && <div css={errorStyle}>{error}</div>}
          </div>
        )}
      </Field>

      <Field name="title" defaultValue="">
        {({ fieldProps, error }) => (
          <div>
            <div css={labelStyle}>Title</div>
            <TextField
              value={fieldProps.value}
              onChange={(e) => fieldProps.onChange(e.currentTarget.value)}
              placeholder="Write a descriptive title"
              onBlur={(e) => setTitle(e.currentTarget.value)}
            />
            {error && <div css={errorStyle}>{error}</div>}
          </div>
        )}
      </Field>
      <Field name="content" defaultValue={content}>
        {({ fieldProps, error }) => (
          <div>
            <div css={labelStyle}>Content</div>
            {/* <Editor placeholder="Provide details about your question" expanded={true} onChange={setContent} /> */}
            {error && <div css={errorStyle}>{error}</div>}
          </div>
        )}
      </Field>

      <div css={tagSuggestionsContainerStyle}>
        <Button appearance="primary" onClick={handleTagSuggestions}>
          Get Tag Suggestions
        </Button>
        {queryReference ? <TagSuggestionsContainer queryReference={queryReference} /> : null}
      </div>
      <Field name="tags" defaultValue="">
        {({ fieldProps, error }) => (
          <div>
            <div css={labelStyle}>Tags</div>
            <TextField
              value={fieldProps.value}
              onChange={(e) => fieldProps.onChange(e.currentTarget.value)}
              placeholder="Enter tags separated by commas (e.g., jira, automation, workflow)"
            />
            {error && <div css={errorStyle}>{error}</div>}
          </div>
        )}
      </Field>
    </>
  );
};

const tagSuggestionsContainerStyle = css({
  paddingTop: '20px',
});

const labelStyle = css({
  fontWeight: 500,
  marginTop: 16,
  display: 'block',
  '& span': {
    color: token('color.text.danger'),
  },
});

const errorStyle = css({
  color: token('color.text.danger'),
  fontSize: '12px',
  marginTop: '4px',
  marginBottom: '8px',
});

const selectStyle = css({
  marginTop: 8,
  marginBottom: 8,
});
